var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuServices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1, 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 1H8.5V8.5H1V1ZM13.5 1H21V8.5H13.5V1ZM1 13.5H8.5V21H1V13.5ZM13.5 17.25C13.5 18.2446 13.8951 19.1984 14.5983 19.9017C15.3016 20.6049 16.2554 21 17.25 21C18.2446 21 19.1984 20.6049 19.9017 19.9017C20.6049 19.1984 21 18.2446 21 17.25C21 16.2554 20.6049 15.3016 19.9017 14.5983C19.1984 13.8951 18.2446 13.5 17.25 13.5C16.2554 13.5 15.3016 13.8951 14.5983 14.5983C13.8951 15.3016 13.5 16.2554 13.5 17.25Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuServices);
export default __webpack_public_path__ + "static/media/menuServices.0655c459cd34c4c915c228ae776bdf8b.svg";
export { ForwardRef as ReactComponent };